import appState from 'lib/appState'
import { handleize } from './util'
import * as CartJS from '@shopify/theme-cart'
import request from 'axios'
class Cart {
  constructor() {
    this.state = null
    this.getState()
  }

  get hasSubscriptionProduct() {
    if (!this.state) return false
    return this.state.items.find(
      ({ properties, title }) => (properties && properties['subscription_id']) || handleize(title).includes('subscription')
    )
  }

  updateNote(note = null) {
    return CartJS.updateNote(note)
  }

  async getState() {
    const state = await CartJS.getState()
    this.state = state
    appState.cart = this.state
    this.fetchCartMeta()
    return this.state
  }

  async fetchCartMeta() {
    const { data } = await request.get('/cart', { params: { view: 'variant-meta' } })
    appState.cartMeta = data
  }

  async add(items = [], updateCart = true) {
    const results = []
    for (const item of items) {
      try {
        const result = await CartJS.addItem(Number(item.id), item)
        results.push(result)
      } catch (error) {
        console.log(error)
      }
    }
    if (updateCart) await this.getState()
    window.MicroBus.emit('cart:add', { state: this.state })
    return this.state
  }

  async update(key, options = {}) {
    const cart = await CartJS.updateItem(key, options)
    this.state = cart
    return this.state
  }

  async updateBundles(items) {
    const test =
      items instanceof Array
        ? items.map(({ id, quantity }) => `updates[${id}]=${quantity}`).join('&')
        : `updates[${items.id}]=${items.quantity}`

    const { data } = await request.post('/cart/update.js', test)
    this.state = data
    return this.state
  }

  async remove(key) {
    const cart = await CartJS.removeItem(key)
    return cart
  }

  async replaceVariant(key, newVariant, { properties = {}, quantity }) {
    await this.remove(key)
    await CartJS.addItem(newVariant, { quantity, properties: { ...properties, _replacementVariant: Date.now() } })
    await this.getState()
    return this.state
  }

  addSubscription(variantId, quantity = 1, frequency = 30, interval = 'Days', subscriptionId, props = {}) {
    const properties = {
      shipping_interval_frequency: frequency,
      shipping_interval_unit_type: interval,
      subscription_id: subscriptionId,
      ...props,
    }
    return this.add([
      {
        id: variantId,
        quantity,
        properties,
      },
    ])
  }

  gotoCheckout() {
    window.location = '/checkout'
    return null
  }

  trackAddToCart(product) {}

  trackCartOpen() {}

  async clearItems() {
    await CartJS.clearItems()
    await this.getState()
    return this.state
  }
}

const cartInstance = new Cart()
export default cartInstance

window.HU__UPDATE_CART__ = () => {
  return cartInstance.getState()
}

window.HU__OPEN_CART__ = () => {
  appState.isMiniCartOpen = true
}

window.HU__CLOSE_CART__ = () => {
  appState.isMiniCartOpen = false
}
